'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _dec3, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRedux = require('react-redux');

var _project = require('redux/modules/project');

var projectActions = _interopRequireWildcard(_project);

var _reduxConnect = require('redux-connect');

var _reactRouter = require('react-router');

var _reactI18next = require('react-i18next');

var _components = require('components');

var _toastr = require('helpers/toastr');

var _toastr2 = _interopRequireDefault(_toastr);

var _projects = require('helpers/projects');

var _asyncPromise = require('helpers/async-promise');

var _asyncPromise2 = _interopRequireDefault(_asyncPromise);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _SharespacePublishButton = require('containers/Project/SharespacePublishButton/SharespacePublishButton');

var _SharespacePublishButton2 = _interopRequireDefault(_SharespacePublishButton);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./ProjectConfirmation.scss');

var showConfirmCheckboxes = false;

var ProjectConfirmation = (_dec = (0, _reduxConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var dispatch = _ref.store.dispatch,
        _ref$params = _ref.params,
        projectId = _ref$params.projectId,
        type = _ref$params.type;
    var loadConfirmation = projectActions.loadConfirmation,
        loadStatusInfo = projectActions.loadStatusInfo,
        loadProject = projectActions.loadProject;

    var id = Number(projectId);
    var promises = [];

    if (type === _projects.projectTypes.sharespace) {
      promises.push(dispatch(loadProject(id)).promise);
    } else {
      promises.push(dispatch(loadConfirmation(id)).promise);
      promises.push(dispatch(loadStatusInfo(id)).promise);
    }

    return (0, _asyncPromise2.default)(_promise2.default.all(promises).catch(function (err) {
      return err;
    }));
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state, ownProps) {
  return {
    confirmation: state.project.confirmationData,
    confirmationLoading: state.project.confirmationLoading,
    projectData: state.project.projectData,
    projectId: Number(ownProps.params.projectId),
    projectLoading: state.project.projectLoading,
    projectType: ownProps.params.type,
    publishLoading: state.project.publishLoading,
    statusInfo: state.project.statusInfoData,
    statusInfoLoading: state.project.statusInfoLoading,
    stopPublishLoading: state.project.stopPublishLoading
  };
}, (0, _extends4.default)({}, projectActions)), _dec3 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = _dec3(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(ProjectConfirmation, _Component);

  function ProjectConfirmation() {
    var _ref2;

    (0, _classCallCheck3.default)(this, ProjectConfirmation);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = ProjectConfirmation.__proto__ || (0, _getPrototypeOf2.default)(ProjectConfirmation)).call.apply(_ref2, [this].concat(args)));

    _this.state = { confirms: { artist: false, title: false, security: false, rights: false } };
    return _this;
  }

  (0, _createClass3.default)(ProjectConfirmation, [{
    key: 'publish',
    value: function publish() {
      var _props = this.props,
          publish = _props.publish,
          projectId = _props.projectId,
          loadStatusInfo = _props.loadStatusInfo,
          t = _props.t;


      if (showConfirmCheckboxes && !this.isConfirmed()) {
        _toastr2.default.warning(t('Please confirm the information to publish the project'));
      } else {
        return publish(projectId).promise.then(function () {
          return loadStatusInfo(projectId);
        }).catch(function (err) {
          return err;
        });
      }
    }
  }, {
    key: 'stopPublish',
    value: function stopPublish() {
      var _props2 = this.props,
          stopPublish = _props2.stopPublish,
          loadStatusInfo = _props2.loadStatusInfo,
          loadConfirmation = _props2.loadConfirmation,
          projectId = _props2.projectId,
          projectType = _props2.projectType;

      return stopPublish(projectId).promise.then(function () {
        if (projectType !== _projects.projectTypes.sharespace) {
          loadConfirmation(projectId);
          loadStatusInfo(projectId);
        }
      }).catch(function (err) {
        return err;
      });
    }
  }, {
    key: 'confirm',
    value: function confirm(field) {
      this.setState({
        confirms: (0, _extends4.default)({}, this.state.confirms, (0, _defineProperty3.default)({}, field, !this.state.confirms[field]))
      });
    }
  }, {
    key: 'isConfirmed',
    value: function isConfirmed() {
      var confirms = this.state.confirms;

      var res = true;

      (0, _keys2.default)(confirms).map(function (field) {
        if (!confirms[field]) {
          res = false;
        }
      });

      return res;
    }

    /* eslint-disable react/no-danger */

  }, {
    key: 'renderProjectConfirm',
    value: function renderProjectConfirm() {
      var _this2 = this;

      var _props3 = this.props,
          t = _props3.t,
          projectId = _props3.projectId,
          projectType = _props3.projectType,
          confirmation = _props3.confirmation,
          statusInfo = _props3.statusInfo,
          publishLoading = _props3.publishLoading,
          stopPublishLoading = _props3.stopPublishLoading,
          confirmationLoading = _props3.confirmationLoading,
          statusInfoLoading = _props3.statusInfoLoading;
      var confirms = this.state.confirms;

      var canStop = statusInfo.canStop;
      var canPublish = confirmation.canProceed && !canStop;
      var showCheckbox = canPublish && showConfirmCheckboxes;
      var isPublishLoading = publishLoading || statusInfoLoading;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'section' },
          _react2.default.createElement(
            'h4',
            null,
            t('We are about to process the files for your recipients.')
          ),
          _react2.default.createElement('div', { className: 'danger margin-top-15', dangerouslySetInnerHTML: { __html: confirmation.warnings } }),
          _react2.default.createElement(
            'div',
            { className: 'hint colorPrimary margin-vert-15' },
            t('Please verify the information below:')
          ),
          confirmationLoading ? _react2.default.createElement(_components.Loader, null) : _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              { className: styles.infoRow },
              showCheckbox ? _react2.default.createElement(_components.Checkbox, { small: true, checked: confirms.artist, onClick: function onClick() {
                  return _this2.confirm('artist');
                }, textAfter: t('Artist') + ':' }) : _react2.default.createElement(
                'div',
                null,
                t('Artist'),
                ':'
              ),
              _react2.default.createElement(
                'div',
                null,
                confirmation.artist
              )
            ),
            _react2.default.createElement(
              'div',
              { className: styles.infoRow },
              showCheckbox ? _react2.default.createElement(_components.Checkbox, { small: true, checked: confirms.title, onClick: function onClick() {
                  return _this2.confirm('title');
                }, textAfter: t('Title') + ':' }) : _react2.default.createElement(
                'div',
                null,
                t('Title'),
                ':'
              ),
              _react2.default.createElement(
                'div',
                null,
                confirmation.title
              )
            ),
            _react2.default.createElement(
              'div',
              { className: styles.infoRow },
              showCheckbox ? _react2.default.createElement(_components.Checkbox, { small: true, checked: confirms.security, onClick: function onClick() {
                  return _this2.confirm('security');
                }, textAfter: t('Security') + ':' }) : _react2.default.createElement(
                'div',
                null,
                t('Security'),
                ':'
              ),
              _react2.default.createElement(
                'div',
                { className: 'danger' },
                confirmation.security
              )
            ),
            _react2.default.createElement(
              'div',
              { className: styles.infoRow },
              showCheckbox ? _react2.default.createElement(_components.Checkbox, { small: true, checked: confirms.rights, onClick: function onClick() {
                  return _this2.confirm('rights');
                }, textAfter: t('Rights') + ':' }) : _react2.default.createElement(
                'div',
                null,
                t('Rights'),
                ':'
              ),
              _react2.default.createElement(
                'div',
                { className: 'danger' },
                confirmation.rights
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.infoRow + ' hint small' },
            _react2.default.createElement('div', null),
            _react2.default.createElement(
              'div',
              null,
              t('We aim to deliver your project in less than 30 minutes but it can sometimes take a little longer'),
              '.',
              _react2.default.createElement('br', null),
              t('We will send you a confirmation email as soon as recipients are notified'),
              '.'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'margin-top-30 text-right' },
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/projects/' + projectType + '/' + projectId + '/recipients', className: 'btn btn-accent wide margin-vert-5' },
            t('Back to project')
          ),
          canPublish && _react2.default.createElement(
            'button',
            { className: 'btn btn-primary pos-rel wide margin-left-20 margin-vert-5', onClick: this.publish, disabled: publishLoading },
            t('Publish'),
            isPublishLoading && _react2.default.createElement(_components.Loader, { mask: true })
          ),
          canStop && _react2.default.createElement(
            'button',
            { className: 'btn btn-danger pos-rel wide margin-left-20 margin-vert-5', onClick: this.stopPublish, disabled: stopPublishLoading },
            t('Stop'),
            '!',
            stopPublishLoading && _react2.default.createElement(_components.Loader, { mask: true })
          )
        )
      );
    }
    /* eslint-enable react/no-danger */

  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props,
          t = _props4.t,
          projectId = _props4.projectId,
          projectData = _props4.projectData,
          projectType = _props4.projectType,
          confirmationLoading = _props4.confirmationLoading,
          statusInfoLoading = _props4.statusInfoLoading,
          projectLoading = _props4.projectLoading;


      return _react2.default.createElement(
        'div',
        { className: 'page' },
        _react2.default.createElement(_reactHelmet2.default, { title: 'Project' }),
        _react2.default.createElement(
          'div',
          { className: 'container-fluid' },
          _react2.default.createElement(
            'h1',
            null,
            t('Confirmation'),
            (confirmationLoading || statusInfoLoading || projectLoading) && _react2.default.createElement(_components.Loader, { small: true, inline: true, right: true })
          ),
          _react2.default.createElement(_components.ProjectBreadcrumbs, { projectId: projectId, projectType: projectType }),
          projectType === _projects.projectTypes.sharespace ? _react2.default.createElement(_SharespacePublishButton2.default, { project: projectData }) : this.renderProjectConfirm()
        )
      );
    }
  }]);
  return ProjectConfirmation;
}(_react.Component), _class3.propTypes = {
  confirmation: _propTypes2.default.object,
  confirmationLoading: _propTypes2.default.bool,
  loadConfirmation: _propTypes2.default.func,
  loadStatusInfo: _propTypes2.default.func,
  projectData: _propTypes2.default.object,
  projectId: _propTypes2.default.number,
  projectLoading: _propTypes2.default.bool,
  projectType: _propTypes2.default.string,
  publish: _propTypes2.default.func,
  publishLoading: _propTypes2.default.bool,
  statusInfo: _propTypes2.default.object,
  statusInfoLoading: _propTypes2.default.bool,
  stopPublish: _propTypes2.default.func,
  stopPublishLoading: _propTypes2.default.bool,
  t: _propTypes2.default.func
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'publish', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'publish'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'stopPublish', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'stopPublish'), _class2.prototype)), _class2)) || _class) || _class) || _class);
exports.default = ProjectConfirmation;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Project/ProjectConfirmation/ProjectConfirmation.js
// module id = 2189
// module chunks = 1